import { useCallback, useRef, useState } from 'react';

/**
 * Loads an unfiltered export row count on demand (e.g. when the export modal opens).
 * Avoids an extra list API call on every page mount.
 */
export function useLazyExportDatasetTotal(fetchTotal) {
  const fetchTotalRef = useRef(fetchTotal);
  fetchTotalRef.current = fetchTotal;

  const [fullExportDatasetTotal, setFullExportDatasetTotal] = useState(undefined);
  const [isLoadingFullExportTotal, setIsLoadingFullExportTotal] = useState(false);

  const loadFullExportDatasetTotal = useCallback(async () => {
    if (fullExportDatasetTotal != null) {
      return fullExportDatasetTotal;
    }

    setIsLoadingFullExportTotal(true);
    try {
      const total = await fetchTotalRef.current();
      if (total != null && Number.isFinite(total)) {
        setFullExportDatasetTotal(total);
        return total;
      }
      return undefined;
    } finally {
      setIsLoadingFullExportTotal(false);
    }
  }, [fullExportDatasetTotal]);

  const resetFullExportDatasetTotal = useCallback(() => {
    setFullExportDatasetTotal(undefined);
  }, []);

  return {
    fullExportDatasetTotal,
    isLoadingFullExportTotal,
    loadFullExportDatasetTotal,
    resetFullExportDatasetTotal,
  };
}
